<template>
  <v-flex fill-height lg12 md12 xs12 class="preautorizzaaioni__wrap">
    <v-card class="fill-height">
      <v-layout wrap>
        <v-flex lg7 md7 xs12>
          <v-layout class="fill-height">
            <Richieste></Richieste>
          <v-divider vertical></v-divider>
          </v-layout>
        </v-flex>
        <v-flex lg5 md5 xs12 d-flex>
          <v-layout class="fill-height">
            <Preautorizzato></Preautorizzato>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
import Richieste from "./Richieste.vue";
import Preautorizzato from "./Preautorizzato.vue";

export default {
  name: "tab-preautorizzato",
  components: { Richieste, Preautorizzato },
  props: {},
  data() {
    return {
      newPre: false,
      deletePre: false,
      loader: false,
      newpreauto: {},
      date: null,
      rowsPerPageItems: [3],
    };
  },
  computed: {
    preautorizzati() {
      return this.$store.getters["gestione/preautorizzati"];
    },
    categorie() {
      return this.$store.getters.getPageData.categorieSpese;
    }
  },
  created() {
  },
  beforeCreate() {
    if (!this.$store.hasModule("gestione")) {
      this.$store.registerModule("gestione", GestioneAdmin);
    }
  },
  methods: {
    allowedMonths: val => val,
    getReport: function(e) {
      this.$store.dispatch("gestione/getMensile", { data: this.date });
    },
    newPreautorizzatoHandler() {
      this.deletePre = false;
      this.newPre = true;
    },
    deletePreautorizzatoHandler() {
      this.newPre = false;
      this.deletePre = true;
    },
    salvaPreautorizzatoHandler() {
      //        console.log(this.newpreauto);
      this.$store.dispatch("gestione/salvaPreautorizzato", {
        ...this.newpreauto
      });
    }
  }
};
</script>

<style lang="scss">
.preautorizzaaioni__wrap {
  .v-list {
    .v-list__tile {
      height: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// modules/Home/views/src/components/TabPreautorizzato.vue